<template lang="pug">
  .vue-blog-nav.row.xs-f-xsmall.md-f-medium.lg-f-xmedium.max-at-tweak
    .nav.xs-12
      .links.xs-12.text-center
        .xs-4.md-3.link-div(:class="{active: $route.path == '/blog/dear-color-crew-what-level-is-my-hair'}")
          a.xs-f-xsmall.md-f-medium.lg-f-xmedium.max-at-tweak(href="/blog/hairstyles") Hairstyles

        .xs-4.md-3.link-div(:class="{active: $route.path == '/blog/hair-tutorials'}")
          a.xs-f-xsmall.md-f-medium.lg-f-xmedium.max-at-tweak(href="/blog/hair-tutorials") Hair&nbsp;Tutorials

        .xs-4.md-3.link-div(:class="{active: $route.path == '/blog/hair-color'}")
          a.xs-f-xsmall.md-f-medium.lg-f-xmedium.max-at-tweak(href="/blog/hair-color") Hair&nbsp;Color

        .xs-hide.md-3.link-div(:class="{active: $route.path == '/blog/inspiration'}")
          a.xs-f-xsmall.md-f-medium.lg-f-xmedium.max-at-tweak(href="/blog/inspiration") Inspiration

      .search.xs-f-medium.lg-f-xmedium.max-at-tweak
        button.open-search.btn-reset.icon-magnify.semi-bold.xs-f-medium.lg-f-xmedium.max-at-tweak(
          type="button"
          @click="toggleSearchBar"
          data-mr-ass="search-icon"
          aria-label="Open search form"
          :aria-expanded="inputBoxVisible.toString()"
          aria-controls="searchInput"
        )
          span.ada-tooltip show search form

        .search-box(:class="{open: inputBoxVisible}")
          form.search-form(@submit.prevent="searchTerm")
            label.tooltip(for="searchInput") Search Blog
            input#searchInput.search-input.xs-f-medium.lg-f-xmedium.max-at-tweak(placeholder="Search" name="search" v-model="searchTermString")
            button.btn-reset.icon-magnify.semi-bold.xs-f-medium.lg-f-xmedium.max-at-tweak(type='submit')
              span.ada-tooltip search

</template>

<script>

  import globalMixins from '@mixins/globalMixins';

  export default {
    mixins: [
      globalMixins
    ],

    data: () => ({
      searchTermString: null,
      inputBoxVisible: false
    }),

    methods: {
      searchTerm() {
        if (this.searchTermString) {
          this.goToPath('/blog/search/' + this.searchTermString);
        } else {
          this.inputBoxVisible = false;
        }
      },

      toggleSearchBar() {
        this.inputBoxVisible = !this.inputBoxVisible;
      }
    }
  };
</script>

<style lang="stylus">

@media mq-tablet-less
  #launcher
    margin-bottom 50px

.vue-blog-nav
  .nav
    height 2.25em

  .links
    .link-div
      a
        line-height 2.25em

  .search
    position absolute
    top 0
    right 0
    bottom 0

    .open-search
      line-height 2.25em

    .search-box
      position absolute
      top 0
      right 0
      bottom 0
      width 0
      transition(width 400ms ease-in-out\, border-color 50ms 300ms ease)
      border 1px solid transparent
      background-color color-white
      overflow hidden
      text-align right

      &.open
        width 22em
        border-color text-color-1
        transition(width 400ms ease-in-out\, border-color 50ms 100ms ease)

      .search-form
        position absolute
        width 22em
        top 0
        right 0
        bottom 0

        input
        button
          display inline-block
          vertical-align top
          margin 0.25em

        input
          width 19em
          border none !important

        button
          width 1.5em

  @media mq-tablet-less
    .nav
      height 3em

    .links
      position fixed
      bottom 0
      left 0
      right 0
      z-index 103
      background-color #000
      height 3.2em

      .link-div
        &.active
          background-color brand-color-1

        a
          color #fff
          display inline-block
          width 100%
          height 3.1em
          line-height 3.1em

    .search
      .search-box
        &.open
          width 18em

        .search-form
          width 18em

          input
            width 15em

  @media mq-desktop-md-plus
    padding 0.25em
    border-top 1px solid #ccc
    box-shadow 0 7px 6px -5px #aaa

</style>